<template>
  <footer class="footer">
    <div class="footer-content">
      <!-- 左侧 Logo 和文字 -->
      <div class="footer-left">
        <div class="logo-text">雨瑞资源</div>
        <p class="motto">
          声明：本站是网盘资源分享平台,所有内容均来源于网络资源，对其内容不负任何责任，若有问题，请联系我们。
        </p>
      </div>

      <!-- 中间链接 -->
      <div class="footer-center">
        <div class="footer-links">
          <a href="#">时间轴</a>
          <span class="divider">·</span>
          <a href="#">友链申请</a>
          <span class="divider">·</span>
          <a href="#">免责声明</a>
          <span class="divider">·</span>
          <a href="#">网站地图</a>
        </div>
        <div class="footer-icp">
<!--          <img src="@/assets/icp.png" alt="ICP" class="icp-icon">-->
<!--          <span>浙ICP备20240318333-1</span>-->
        </div>
        <div class="footer-copyright">
          Copyright © 2020-2024 雨瑞版权所有
        </div>
      </div>

      <!-- 右侧二维码 -->
      <div class="footer-right">
        <div class="qrcode-container">
          <div class="qrcode-item">
            <img :src="'/assets/' + encodeURI('126.jpg')" alt="雨瑞资源QQ群" class="qr-image">
            <span>扫码加QQ群</span>
          </div>
<!--          <div class="qrcode-item">-->
<!--&lt;!&ndash;            <img src="@/assets/wechat-qr.png" alt="微信" class="qr-image">&ndash;&gt;-->
<!--            <span>扫码加微信</span>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background: #fff;
  padding: 40px 0;
  border-top: 1px solid #eee;
  margin-top: 60px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

/* 左侧样式 */
.footer-left {
  flex: 1;
  max-width: 400px;
}

.logo-text {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.motto {
  color: #666;
  font-size: 14px;
  line-height: 1.8;
}

/* 中间部分样式 */
.footer-center {
  flex: 1;
  text-align: center;
  padding: 0 40px;
}

.footer-links {
  margin-bottom: 20px;
}

.footer-links a {
  color: #666;
  text-decoration: none;
  font-size: 14px;
}

.footer-links a:hover {
  color: #1890ff;
}

.divider {
  margin: 0 8px;
  color: #ccc;
}

.footer-icp {
  color: #999;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.icp-icon {
  height: 16px;
  width: auto;
}

.footer-copyright {
  color: #999;
  font-size: 14px;
}

/* 右侧二维码样式 */
.footer-right {
  flex: 1;
  max-width: 300px;
}

.qrcode-container {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

.qrcode-item {
  text-align: center;
}

.qr-image {
  width: 120px;
  height: 120px;
  display: block; /* 确保图片显示 */
  margin-bottom: 8px;
}

.qrcode-item span {
  color: #666;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .footer-left, .footer-center, .footer-right {
    max-width: 100%;
    margin-bottom: 30px;
  }

  .qrcode-container {
    justify-content: center;
  }
}

@media (max-width: 640px) {
  .qrcode-container {
    flex-direction: column;
    align-items: center;
  }
}
</style>
